import axios from 'axios';
import { getToken, genAuthorization } from './auth';
import request from 'assets/js/request.js';

export function downloadFile(fileId, fileUid, filename) {
  request({
    method: 'POST',
    headers: {
      Authorization: getToken(),
    },
    url: '/portfolio/gather/dowloadTemplate',
    data: { fileId: fileId, fileUid: fileUid },
    responseType: 'blob',
  })
    .then(function(response) {
      if (response.type == 'application/octet-stream') {
        const blob = new Blob([response]);
        var downloadElement = document.createElement('a');
        // var href = window.URL.createObjectURL(blob);
        // var href = window.navigator.msSaveOrOpenBlob(blob, filename);
        if ('msSaveOrOpenBlob' in navigator) {
          // 兼容IE/Edge
          window.navigator.msSaveOrOpenBlob(blob, filename);
        } else {
          var href = window.URL.createObjectURL(blob);
          downloadElement.href = href;
          downloadElement.download = filename;
          downloadElement.download = decodeURIComponent(
            downloadElement.download
          );
          document.body.appendChild(downloadElement);
          downloadElement.click();
          document.body.removeChild(downloadElement);
          window.URL.revokeObjectURL(href);
        }
      }
    })
    .catch(function(error) {
      console.log(error);
    });
}
